import irpfMetadata from './data/metadata.json';
import type { IrpfDataVersion } from './types.js';

export const IRPF_DATA_VERSION: IrpfDataVersion = irpfMetadata as IrpfDataVersion;
